import { useTheme } from '@mui/material';

export const ErrorIconAccessDenied = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            width="328"
            height="230"
            viewBox="0 0 328 230"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M225.762 169.157L213.334 102.467L305.404 85.1059L318.907 155.93L225.762 169.157Z"
                fill={primaryBackground}
            />
            <path
                d="M311.334 145.659C310.306 144.152 304.068 104.606 300.566 81.6994C300.234 79.5259 298.212 78.0348 296.037 78.3503L200.147 92.2543L294.866 80.9839C297.013 80.7284 298.975 82.226 299.295 84.3648L307.858 141.671C308.186 143.868 306.679 145.91 304.479 146.221C273.406 150.614 217.897 158.503 216.368 158.885C214.771 159.285 206.885 117.293 203.142 96.2472L213.953 158.764C214.324 160.911 216.331 162.368 218.484 162.037C252.166 156.861 312.382 147.195 311.334 145.659Z"
                fill={primaryStroke}
            />
            <path
                d="M243.98 51.9288C268.443 48.8218 280.184 69.5023 282.997 80.2309L284.648 80.0077C281.464 69.0559 268.729 47.9736 243.266 51.2592C217.803 54.5447 213.521 78.4007 214.562 89.9179H215.946C215.098 78.5495 219.518 55.0358 243.98 51.9288Z"
                fill={primaryStroke}
            />
            <path
                d="M71.6919 151.928C65.3029 153.754 5.06372 153.754 0.5 159.23C13.643 170.183 20.5798 210.646 22.4053 229.509H96.3352C93.9013 225.858 87.9382 215.088 83.5572 201.215C78.0809 183.873 78.0809 150.103 71.6919 151.928Z"
                fill={primaryBackground}
            />
            <path
                d="M54.7667 23.2682C52.0667 24.0396 26.6098 24.0396 24.6812 26.3539C30.2354 30.9825 33.1668 48.0823 33.9383 56.0537H65.1809C64.1524 54.5109 61.6324 49.9595 59.781 44.0966C57.4667 36.7681 57.4667 22.4968 54.7667 23.2682Z"
                fill={primaryBackground}
            />
            <path
                d="M39.834 209.009C32.234 193.809 14.6673 98.6758 6.83398 53.0091C26.7318 99.004 17.9053 200.298 62.4332 211.598C99.013 220.881 287.334 204.236 311.334 191.509C335.334 178.782 324.834 121.341 320.834 56.8414C317.436 2.05382 311.711 4.71864 294.158 4.71864C282.158 4.71864 275.712 4.30095 206.212 8.30096C150.612 11.501 60.5007 23.5091 23.334 28.5091C122.501 13.0091 320.834 -12.4909 320.834 9.50912C320.834 37.0091 339.834 195.509 311.334 201.009C282.834 206.509 49.334 228.009 39.834 209.009Z"
                fill={primaryStroke}
            />
            <ellipse
                cx="24.3817"
                cy="43.993"
                rx="2.6814"
                ry="3.4473"
                transform="rotate(-32.3471 24.3817 43.993)"
                fill={primaryStroke}
            />
            <ellipse
                cx="32.6015"
                cy="42.5153"
                rx="2.6814"
                ry="3.4473"
                transform="rotate(-32.3471 32.6015 42.5153)"
                fill={primaryStroke}
            />
            <ellipse
                cx="40.8212"
                cy="41.1236"
                rx="2.6814"
                ry="3.4473"
                transform="rotate(-32.3471 40.8212 41.1236)"
                fill={primaryStroke}
            />
            <path
                d="M17.334 55.6117C17.3605 55.5738 17.8496 55.4784 18.7601 55.3309C24.4418 54.2746 36.0666 52.7148 51.7245 50.8276C108.343 43.4186 217.778 29.8367 246.414 27.7779C277.669 25.5308 302.717 24.1178 311.334 23.6922C241.951 30.447 114.463 43.2658 51.7245 50.8276C34.9172 53.0269 22.764 54.6823 18.7601 55.3309C18.2331 55.4289 17.7572 55.5225 17.334 55.6117Z"
                fill={primaryStroke}
            />
            <path
                d="M122.566 65.0599C112.964 65.877 63.2381 72.3801 39.5752 75.5295C39.5752 76.5509 104.436 68.1241 136.866 63.7831C136.1 63.8682 132.167 64.2427 122.566 65.0599Z"
                fill={primaryStroke}
            />
            <path
                d="M46.9807 97.7454C72.0056 94.0002 128.592 85.6415 154.741 82.1687C172.495 79.8108 185.132 77.9473 192.748 76.754C195.33 76.3307 197.818 75.9216 200.194 75.5295C198.828 75.7754 196.349 76.1898 192.748 76.754C139.837 85.4273 46.9807 100.083 46.9807 97.7454Z"
                fill={primaryStroke}
            />
            <path
                d="M49.0235 124.813C74.7294 121.238 128.286 114.037 136.866 113.833C139.036 113.781 141.655 113.609 144.465 113.363C153.016 112.319 160.987 111.344 167.764 110.513C162.74 111.276 152.767 112.638 144.465 113.363C103.938 118.312 50.3731 124.813 49.0235 124.813Z"
                fill={primaryStroke}
            />
            <path
                d="M55.6628 155.201C67.1538 152.732 96.9794 147.233 124.354 144.986C129.416 144.571 133.986 144.155 138.092 143.747L167.764 139.624C165.266 140.318 156.187 141.95 138.092 143.747L55.6628 155.201Z"
                fill={primaryStroke}
            />
            <path
                d="M160.103 177.927C152.749 178.949 90.4763 182.438 60.2592 184.056L176.446 175.118C174.063 175.629 167.458 176.906 160.103 177.927Z"
                fill={primaryStroke}
            />
            <path
                d="M246.268 115.265C243.715 111.436 247.332 106.649 249.46 104.735C245.248 111.584 246.586 111.194 247.092 114.484C247.599 117.773 252.811 117.925 252.811 120.212C252.811 122.499 254.835 132.55 255.088 133.562C255.341 134.574 262.703 136.699 261.717 132.145C260.929 128.501 259.77 121.99 259.288 119.19C260.975 118.211 264.086 115 263.033 109.98C261.981 104.96 255.035 103.434 251.693 103.299C255.363 102.713 262.958 103.139 263.979 109.521C265 115.904 262.383 119.308 260.947 120.212C261.692 123.456 263.086 130.551 262.703 132.976C262.224 136.008 256.639 136.646 254.406 134.412C252.619 132.625 251.853 124.201 251.693 120.212C250.949 120.159 248.821 119.095 246.268 115.265Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
